import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {ButtonComponent} from '../../../components/button/eretail-button/button.component';
import {MatIconModule} from '@angular/material/icon';
import {AuthService} from '../../../../core/services/auth.service';
import {OverlayLoadingComponent} from 'src/app/shared/components/loading/overlay-loading/overlay-loading.component';
import {UserService} from 'src/app/core/services/user.service';

@Component({
  standalone: true,
  templateUrl: './confirm-exit-dialog.component.html',
  imports: [MatButtonModule, MatDialogModule, MatIconModule, ButtonComponent],
})
export class ConfirmExitDialog {
  private _auth = inject(AuthService);
  private _dialog = inject(MatDialog);
  private _user = inject(UserService);

  logOut() {
    const loadingDialog = this._dialog.open(OverlayLoadingComponent, {
      minWidth: 'unset',
      maxWidth: 'unset',
    });
    this._user.clearUser();
    this._auth.logout();

    setTimeout(() => {
      loadingDialog.close();
    }, 2000);
  }
}
